import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { TOGGLE_LOCALE } from './IwIntlProvider.actions';

const mapStateToProps = (state: RootState) => ({
    isImpersonating: state.siteContext.impersonating,
    ...state.intl
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    toggleLocale: () => {
        dispatch({ type: TOGGLE_LOCALE });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const ToggleLocale = ({
    language,
    isImpersonating,
    toggleLocale
}: PropsFromRedux) => {
    if (!isImpersonating) return null;

    return (
        <div className="fixed bottom-[80px] right-m">
            <button
                className="rounded-full bg-primary-40 p-s text-s text-structure-100 hover:opacity-80"
                onClick={toggleLocale}
            >
                {language === 'en' ? 'EN' : 'DE'}
            </button>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(ToggleLocale);
